import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
import { jsx as o } from "react/jsx-runtime";
import { calculateRem as n } from "@vds-core/utilities";
import e, { keyframes as t, css as i } from "styled-components";
import { Component as r } from "react";
import { ComponentTokens as d } from "@vds-tokens/component";
var l = t(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"]))),
  a = t(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"]))),
  c = e.div.withConfig({
    displayName: "Overlay",
    componentId: "VDS__sc-1i7xx3y-0"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  padding: ", ";\n\n  @media (max-width: 767px) {\n    padding: 0;\n  }\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
    var o = _ref.$fullScreenDialog,
      n = _ref.viewport,
      e = _ref.surface;
    return o || "mobile" === n ? "transparent" : "dark" === e ? d.modal.background.overlay.ondark.value : d.modal.background.overlay.onlight.value;
  }, function (_ref2) {
    var o = _ref2.$fullScreenDialog,
      e = _ref2.viewport;
    return o || "mobile" === e ? "0" : n(16);
  }, function (_ref3) {
    var o = _ref3.$modalOpened;
    return o && i(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      animation: ", " 0.4s\n        cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n    "])), l);
  }, function (_ref4) {
    var o = _ref4.$unmounted;
    return o && i(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      animation: ", " 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n    "])), a);
  });
var u = /*#__PURE__*/function (_r) {
  _inherits(u, _r);
  function u() {
    var _this;
    _classCallCheck(this, u);
    var o;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(u).apply(this, arguments)), o = _assertThisInitialized(_assertThisInitialized(_this)), _this.handleDown = function (n) {
      var e, t;
      27 === n.keyCode && (null === (t = (e = o.props).onDismiss) || void 0 === t || t.call(e));
    }, _this.onClick = function (n) {
      var e, t;
      o.props.disableOutsideClick || n.target.contains(o.overlayRef) && (null === (t = (e = o.props).onDismiss) || void 0 === t || t.call(e));
    };
    return _this;
  }
  _createClass(u, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var o;
      "undefined" != typeof document && (null === (o = null === document || void 0 === document ? void 0 : document.addEventListener) || void 0 === o || o.call(document, "keydown", this.handleDown));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var o;
      "undefined" != typeof document && (null === (o = null === document || void 0 === document ? void 0 : document.removeEventListener) || void 0 === o || o.call(document, "keydown", this.handleDown));
    }
  }, {
    key: "render",
    value: function render() {
      var n = this;
      var _this$props = this.props,
        e = _this$props.children,
        t = _this$props.fullScreenDialog,
        i = _this$props.noMobilePadding,
        r = _this$props.viewport,
        d = _this$props.unmounted,
        l = _this$props.modalOpened,
        a = _this$props.surface;
      return o(c, {
        $unmounted: d,
        $modalOpened: l,
        $fullScreenDialog: t,
        onMouseDown: this.onClick,
        noMobilePadding: i,
        viewport: r,
        ref: function ref(o) {
          n.overlayRef = o;
        },
        surface: a,
        children: e
      });
    }
  }]);
  return u;
}(r);
export { u as default };